@if (featureRequest) {
<div class="dialogContainer">
  <div class="dialogHeader">
    <img
      class="closeButton"
      src="/images/closeIconWithoutBox.png"
      (click)="closeDialog()"
    />
  </div>
  <div class="dialogContent">
    <app-dialog-input-title
      title="Feature"
      [required]="true"
    ></app-dialog-input-title>
    <select [(ngModel)]="featureRequest.featureOptionId">
        <option value="0" class="hidden">Vælg Feature</option>
        @for (featureOption of featureOptions; track featureOption.id) {
        <option [ngValue]="featureOption.id">
            {{ featureOption.name }}
        </option>
        }
    </select>
    <app-dialog-input-title
      title="Antal"
      [required]="true"
    ></app-dialog-input-title>
    <input
      type="number"
      [ngModel]="featureRequest.amount"
      (ngModelChange)="featureRequest.amount = numberConversion($event)"
    />
    <app-dialog-input-title
      title="Kunde"
      [required]="true"
    ></app-dialog-input-title>
    <select [(ngModel)]="featureRequest.clientId"
            (ngModelChange)="clientCascade($event)">
        <option value="null" class="hidden">Vælg Kunde</option>
        @for (client of clients; track client.id) {
        <option [ngValue]="client.id">
            {{ client.name }}
        </option>
        }
    </select>
    @if(featureRequest.clientId != null && shownPlants.length > 0){

    <app-dialog-input-title
      title="Anlæg"
    ></app-dialog-input-title>
    <select [(ngModel)]="featureRequest.plantId">
      <option value="null" >(Intet Anlæg valgt)</option>
      @for (plant of shownPlants; track plant.id) {
      <option [ngValue]="plant.id">
        {{ plant.plantName }}
      </option>
      }
    </select>
    }
  </div>
  <div class="dialogFooter">
    <app-save-button
      [disabled]="
        featureRequest.clientId == 0 ||
        featureRequest.amount == 0 ||
        featureRequest.featureOptionId == 0
      "
      [clickEvent]="saveChanges.bind(this)"
    >
    </app-save-button>
    @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin) {
    <app-delete-button [clickEvent]="deleteEntry.bind(this)">
    </app-delete-button>
    }
  </div>
</div>
}
